import React from 'react';
import { FiX } from 'react-icons/fi';
import './Modal.css';

const Modal = ({ show, onClose, title, children, large, contentClassName }) => {
  if (!show) return null;

  const contentClasses = [
    'modal-content',
    large ? 'modal-large' : '',
    contentClassName || '',
  ]
    .filter(Boolean)
    .join(' ');

  return (
    <div className="modal-overlay" onClick={onClose}>
      <div className={contentClasses} onClick={(e) => e.stopPropagation()}>
        <div className="modal-header">
          <h2>{title}</h2>
          <button className="modal-close" onClick={onClose}>
            <FiX />
          </button>
        </div>
        <div className="modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default Modal;
